// extracted by mini-css-extract-plugin
export default {"faqAgentAdvantages":"faqAgentAdvantages_DU1Ky","title":"title_Efst0","list":"list_mCVn6"};